module.exports = __webpack_public_path__ + "media/images/forbes-ab1dcf41874948815b92a708bd6edc486de4fac71d99a247e30421d21eab1455.png";